import InputController from './input_controller'

// NOTE: allows to add border to check/uncheck checkbox buttons
export default class extends InputController {
  clear (): void {
    this.element.checked = false
  }
}
